module.exports = __webpack_public_path__ + "img/abous.8a3a2289.jpg";